import { render, staticRenderFns } from "./View.vue?vue&type=template&id=9d74fa06&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d74fa06')) {
      api.createRecord('9d74fa06', component.options)
    } else {
      api.reload('9d74fa06', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=9d74fa06&", function () {
      api.rerender('9d74fa06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/recaps/View.vue"
export default component.exports